// extracted by mini-css-extract-plugin
export default {"pageLayout":"pa-z","mainContent":"qa-z","columnLayout":"ra-z","columnLayoutFill":"sa-z","columnLayoutLast":"ta-z"};